import React from "react";
import "./Delete_app.css";

function DeleteApp() {
  return (
    <div className="TodoDelete">
      <div className="TodoDelete-body">
        <div className="box">
          <h1>ToDo のアプリ削除／アカウント削除について</h1>

          <h2>結論（大事なポイント）</h2>
          <p>
            <strong>端末からアプリを削除</strong>すると、端末内のアプリは消えます。
            <br />
            ただし、本アプリは機能提供の都合上、タスク等のデータを外部サービス上に保存する場合があります。
            <br />
            そのため、<strong>アプリ削除だけでは外部サービス上のデータが残る場合があります</strong>。
            データも削除したい場合は、下記の「アカウント削除」を実行してください。
          </p>

          <h2>1. アプリ削除（端末から消す）</h2>
          <p>iPhoneのホーム画面で本アプリのアイコンを長押しし、「Appを削除」から削除してください。</p>

          <h2>2. アカウント削除（外部サービス上のデータ削除）</h2>
          <p>
            本アプリ内の「設定」等からアカウント削除を実行できます。
            アカウント削除により、外部サービス上に保存されたタスク等のデータ削除が行われます。
          </p>

          <h2>3. うまく削除できない場合</h2>
          <p>
            アプリにログインできない等の理由でアカウント削除を実行できない場合は、以下へご連絡ください。
            <br />
            メール：haruki2021promoter@gmail.com
          </p>

          <p style={{ marginTop: 18, opacity: 0.85 }}>※ 本ページの内容は、必要に応じて更新されます。</p>
        </div>
      </div>
    </div>
  );
}

export default DeleteApp;
